import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from '../atom/Button';
import { Flex } from '../atom/Layout';
import { Text } from '../atom/Text';
import { HorizonGreyLine } from '../atom/HorizonGreyLine';
import { InputForm } from '../organism/InputForm';
import {
  AllowMarketingCheck,
  AllowMarketingNotiModal,
  doConfirmAllowMarketing,
} from '../organism/AllowMarketing';
import Loading from '../organism/Loading';

import * as api from '../../../lib/api/api';
import * as PATH from '../../../lib/routes/path';
import { ERROR_RETRY, STATUS_MESSAGE } from '../../../lib/Error';
import {
  onAlertStatusError,
  onHandleStatusError,
} from '../../../Hooks/useError';
import { useInput } from '../../../Hooks/useInput';
import { AUTH_VALIDATE } from '../../../Hooks/useAuth';
import ModalContext from '../../../modules/contexts/Modalcontext';
import { doChangeUserAllowMarketing } from '../../../lib/util/userContract';

const AccountTemplate = () => {
  const history = useHistory();
  const { onModal } = useContext(ModalContext).actions;

  const validate = {
    ...AUTH_VALIDATE,
    passwordConfirm: (value) => state.password !== value,
  };

  const { state, setValue, setValueAll, onChangeValue, onChange } = useInput({
    initialState: {
      name: '',
      email: '',
      mobile: '',
      oldPassword: '',
      password: '',
      passwordConfirm: '',
      changeMobile: '',
      validationId: '',
      code: '',
      codeConfirm: false,
      isCodeConfirmLoading: false,
      isValidationMobileCodeLoading: false,
      isLoadingHandlePassword: false,
      updateDateTime: '',
      isPageLoading: false,
      contract: {},
    },
    validate,
  });

  const {
    name,
    email,
    mobile,
    buttonDisplay,
    changeMobile,
    code,
    codeConfirm,
    passwordError,
    passwordConfirmError,
    updateDateTime,
    isCodeConfirmLoading,
    isValidationMobileCodeLoading,
    isLoadingHandlePassword,
    isPageLoading,
    contract,
  } = state;

  const initialState = {
    휴대폰: false,
    비밀번호: false,
    인증번호: false,
  };
  const [isOnEditAccount, setIsOnEditAccount] = useState(initialState);

  useEffect(() => {
    getUserInfo();
  }, []);

  const getUserInfo = () => {
    const id = sessionStorage._id;
    setValue({ name: 'isPageLoading', value: true });

    api
      .getInfo({ id })
      .then((response) => {
        const { contactInfo, name, email, updateDateTime, contract } =
          response.data;
        const tempMobile =
          contactInfo === null
            ? ''
            : contactInfo.mobile === null
            ? ''
            : contactInfo.mobile;
        setValueAll({
          object: {
            name,
            email,
            mobile: tempMobile,
            updateDateTime,
            contract,
          },
        });
      })
      .finally(() => setValue({ name: 'isPageLoading', value: false }));
  };

  const handleMobile = (e) => {
    setValueAll({
      object: {
        changeMobile: e.target.value,
        codeConfirm: false,
      },
    });
  };

  const handleUser = () => {
    const mobile = changeMobile;
    const message = STATUS_MESSAGE.user.changeMobile;
    api
      .changeUserInfo({ mobile, name })
      .then((response) => {
        setIsOnEditAccount(initialState);

        alert(message[200]);
        getUserInfo();
      })
      .catch((error) => {
        const { status } = error.response;
        onHandleStatusError({
          message,
          error,
          errorHandler: () => {
            alert(message[status]);
          },
        });
      })
      .finally(() =>
        setValueAll({
          object: {
            changeMobile: '',
            code: '',
          },
        }),
      );
  };

  const isValidateTrue = {
    password: [passwordError, passwordConfirmError].every(
      (error) => error === null,
    ),
  };
  const handlePassword = () => {
    const { oldPassword, password } = state;
    const message = STATUS_MESSAGE.user.changePassword;

    isValidateTrue.password &&
      setValue({ name: 'isLoadingHandlePassword', value: true });
    api
      .changePassword({ oldPassword, password })
      .then((response) => {
        alert(message[200]);
        setIsOnEditAccount(initialState);

        setValueAll({
          object: {
            oldPassword: '',
            password: '',
            passwordConfirm: '',
          },
        });
      })
      .catch((error) => {
        onAlertStatusError({ message, error });
      })
      .finally(() => {
        setValue({ name: 'isLoadingHandlePassword', value: false });
      });
  };

  const cancelMobileBox = () => {
    setIsOnEditAccount({ ...isOnEditAccount, 휴대폰: false, 인증번호: false });
    setValueAll({
      object: {
        changeMobile: '',
        code: '',
      },
    });
  };

  const handleIssueCode = () => {
    const message = STATUS_MESSAGE.user.validateMobileCode;
    if (mobile === changeMobile) {
      alert(message['SAME_CODE']);
    } else {
      const message = '[베이비페이스]인증번호를 입력해주세요. ';
      const phoneNumber = changeMobile;

      setValue({ name: 'isCodeConfirmLoading', value: true });
      api
        .issueMobileCode({ message, phoneNumber })
        .then((response) => {
          setValueAll({
            object: {
              validationId: response.data.id,
              codeConfirm: true,
            },
          });
          setIsOnEditAccount({ ...isOnEditAccount, 인증번호: true });
        })
        .catch(() => {
          alert(ERROR_RETRY);
          setValue({ name: 'code', value: '' });
        })
        .finally(() =>
          setValue({ name: 'isCodeConfirmLoading', value: false }),
        );
    }
  };

  const completeMobileBox = () => {
    const message = STATUS_MESSAGE.user.validateMobileCode;

    if (codeConfirm) {
      const validationCode = code;
      const { validationId } = state;

      setValue({ name: 'isValidationMobileCodeLoading', value: true });

      api
        .validationMobileCode({ validationId, validationCode })
        .then((response) => {
          const { result } = response.data;
          if (result === 'SUCCESS' || result === 'PENDING') {
            handleUser();
          } else if (Object.keys(message).includes(result)) {
            alert(message[result]);
          } else {
            alert(ERROR_RETRY);
          }
        })
        .catch((e) => alert(ERROR_RETRY))
        .finally(() =>
          setValue({ name: 'isValidationMobileCodeLoading', value: false }),
        );
    } else {
      alert(message['REQUIRE_VALIDATION']);
    }
  };

  const doClickAllowMarketingCheck = (allowMarketing) => {
    if (doConfirmAllowMarketing(contract.allowMarketing)) {
      doChangeUserAllowMarketing({
        contract,
        allowMarketing,
        afterChangeContract: (data) => {
          setValue({ name: 'contract', value: data.contract });
          onModal({
            title: '마케팅 동의 안내',
            content: (
              <AllowMarketingNotiModal
                updateDateTime={data.updateDateTime}
                allowMarketing={data.contract.allowMarketing}
              />
            ),
          });
        },
      });
    }
  };

  return isPageLoading ? (
    <Loading />
  ) : (
    <Flex column alignItems="stretch" padding="0.625rem 0">
      <Text weight="medium" style={{ marginBottom: '0.625rem' }}>
        기본 정보
      </Text>
      {[
        { label: '이름', value: name, widthButton: false },
        { label: '이메일', value: email, widthButton: false },
        {
          label: '휴대폰',
          value: isOnEditAccount['휴대폰'] ? (
            <input
              type="number"
              name="changeMobile"
              onChange={handleMobile}
              value={changeMobile}
              placeholder="휴대폰 번호를 입력하세요"
              style={{ width: '100%' }}
            />
          ) : (
            mobile
          ),
          widthButton: true,
        },
        {
          label: '비밀번호',
          value: isOnEditAccount['비밀번호'] ? (
            <InputForm
              state={state}
              onChangeValue={onChangeValue}
              formData={EDITPASSWORD_DATA}
              onSubmit={handlePassword}
            >
              <Button
                onClick={isValidateTrue.password ? handlePassword : undefined}
                color={isValidateTrue.password ? 'orangePink' : 'pinkishGrey'}
                style={{ marginTop: '1.25rem' }}
                isLoading={isLoadingHandlePassword}
              >
                비밀번호 변경
              </Button>
            </InputForm>
          ) : (
            `최종수정일 ${updateDateTime}`
          ),
          widthButton: true,
        },
      ].map((content) => (
        <React.Fragment key={content.label}>
          <Flex
            column
            alignItems="flex-start"
            padding="0.625rem 0"
            style={{
              borderBottom:
                content.label !== '비밀번호' && '0.063rem solid #c7c7c7',
              marginBottom: '0.625rem',
            }}
          >
            <Text size={14} style={{ marginBottom: '0.625rem' }}>
              {content.label}
            </Text>
            {content.widthButton ? (
              <Flex column alignItems="stretch" width="100%">
                <Flex justifyContent="space-between" width="100%">
                  <Text size={14} style={{ flex: 4 }}>
                    {content.value}
                  </Text>
                  {!isOnEditAccount[content.label] && (
                    <Button
                      size="small"
                      onClick={() =>
                        setIsOnEditAccount({
                          ...isOnEditAccount,
                          [content.label]: true,
                        })
                      }
                      style={{ flex: 1 }}
                    >
                      <Text size={14}>{content.value ? '수정' : '등록'}</Text>
                    </Button>
                  )}
                  {isOnEditAccount['휴대폰'] && content.label === '휴대폰' && (
                    <Flex>
                      <Button
                        size="small"
                        color="brownGrey"
                        onClick={cancelMobileBox}
                        style={{
                          marginRight: '0.625rem',
                          width: '3rem',
                          height: '1.25rem',
                        }}
                      >
                        <Text size={14}>취소</Text>
                      </Button>
                      <Button
                        size="small"
                        color={
                          isOnEditAccount['인증번호']
                            ? 'pinkishGrey'
                            : 'orangePink'
                        }
                        isLoading={isCodeConfirmLoading}
                        onClick={handleIssueCode}
                        style={{
                          height: '1.25rem',
                          width: '6rem',
                        }}
                      >
                        <Text size={14} style={{ whiteSpace: 'nowrap' }}>
                          인증번호 받기
                        </Text>
                      </Button>
                    </Flex>
                  )}
                </Flex>
              </Flex>
            ) : (
              <Text size={14}>{content.value}</Text>
            )}
          </Flex>
          {isOnEditAccount['휴대폰'] &&
            !isOnEditAccount['인증번호'] &&
            content.label === '휴대폰' && (
              <Text
                size={14}
                color="brownGrey"
                style={{ marginBottom: '0.625rem' }}
              >
                휴대폰 번호 변경을 위해 인증이 필요합니다.
              </Text>
            )}
          {isOnEditAccount['인증번호'] && content.label === '휴대폰' && (
            <Flex
              justifyContent="space-between"
              width="100%"
              padding="0.625rem 0"
              style={{
                borderBottom: '0.063rem solid #c7c7c7',
                marginBottom: '0.625rem',
              }}
            >
              <input
                type="number"
                name="code"
                onChange={onChange}
                value={code}
                style={{ flex: 3 }}
                placeholder="인증번호 입력"
              />
              <Button
                size="small"
                onClick={completeMobileBox}
                display={buttonDisplay}
                isLoading={isValidationMobileCodeLoading}
                style={{ flex: 1, width: '6rem', height: '1.25rem' }}
              >
                <Text size={14}>수정완료</Text>
              </Button>
            </Flex>
          )}
        </React.Fragment>
      ))}
      <HorizonGreyLine />
      <AllowMarketingCheck
        margin="1.875rem 0 0"
        allowMarketing={contract.allowMarketing}
        onClick={() => doClickAllowMarketingCheck(!contract.allowMarketing)}
      />
      <Flex column padding="1.875rem 0 0.625rem" alignItems="stretch">
        <Text>회원탈퇴</Text>
        <Flex justifyContent="space-between" padding="0.625rem 0 0">
          <Text color="brownGrey" size={14} style={{ flex: 4 }}>
            탈퇴 시 기존 주문 내역은 삭제됩니다
          </Text>
          <Button
            size="small"
            color="brownGrey"
            style={{ flex: 1 }}
            onClick={() => history.push(PATH.MYPAGE_ACCOUNT_WITHDRAWAL)}
          >
            <Text size={14}>탈퇴</Text>
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default AccountTemplate;

const EDITPASSWORD_DATA = [
  {
    type: 'password',
    name: 'oldPassword',
    mainIconName: 'lock',
    subIconName: 'visibility',
    placeholder: '비밀번호를 입력하세요.',
  },
  {
    type: 'password',
    name: 'password',
    mainIconName: 'lock',
    subIconName: 'visibility',
    placeholder: '새 비밀번호를 입력하세요.',
  },
  {
    type: 'password',
    name: 'passwordConfirm',
    mainIconName: 'lock',
    subIconName: 'visibility',
    placeholder: '새 비밀번호 확인',
  },
];
